// Copyright 2025, University of Maryland, All Rights Reserved

/**
 * Design tokens for print output.
 * Shared across all application print renderers.
 */

/** Color palette for print output */
export const PRINT_COLORS = {
  // Neutrals
  ink: '#1a1a2e',
  inkMuted: '#4a4a68',
  inkLight: '#6b7280',
  surface: '#ffffff',
  surfaceMuted: '#f8f9fc',
  border: '#e5e7eb',
  borderLight: '#f0f1f3',

  // Risk level colors (background, border, text)
  high: { bg: '#fef2f2', border: '#fecaca', text: '#b91c1c', dot: '#ef4444' },
  medium: { bg: '#fffbeb', border: '#fcd34d', text: '#b45309', dot: '#f59e0b' },
  low: { bg: '#f0fdf4', border: '#bbf7d0', text: '#166534', dot: '#22c55e' },

  // Priority colors
  required: { bg: '#fef2f2', border: '#fecaca', text: '#b91c1c', dot: '#ef4444' },
  critical: { bg: '#fffbeb', border: '#fcd34d', text: '#b45309', dot: '#f59e0b' },
  preferred: { bg: '#f0fdf4', border: '#bbf7d0', text: '#166534', dot: '#22c55e' },

  // Accent
  accent: '#3b5998',
  accentLight: '#eff3ff',
} as const
